// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_39-1";
export var rateTableServiceLevelDropdown = "_39-3";
export var rateTableTypeDropdown = "_39-0";
export var rateTableValueModeDropdown = "_39-2";